import { Link as RRDLink, useLocation, useResolvedPath, } from 'react-router-dom';
import React from 'react';
import * as pageService from '../../Services/Loader';
import { useLinkClickHandler } from 'react-router-dom';

//{ replace, state, target, to, children, type, classname, active, onclick , ...rest } ,ref
const Link = React.forwardRef(({ replace, state, target, to, children, type, classname, active, onclick, ...rest }, className, ref) => {
  const [, startTransition] = React.useTransition();
  let location = useLocation();
  let internalOnClick = useLinkClickHandler(to, { replace, state, target });
  let path = useResolvedPath(to);
  function handleClick(e) {
    e.preventDefault();
    startTransition(() => { pageService.startLoading(); internalOnClick(e) });
    /* console.log("loca" + location.pathname) ; 
    console.log("path" + path.pathname) */
    if (location.pathname === path.pathname) {
      pageService.startLoading();
      pageService.stopLoading();
    }
    else {
      //pageService.stopLoading();
    }
  }
  return (
    <RRDLink onClick={handleClick} className={classname} to={to} replace={replace} state={state} target={target} {...rest} > {children} </RRDLink>
  );
}
);

export default Link;
